import { Injectable } from '@angular/core';
import { Device, DeviceId } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  #deviceId: string | null = null;

  /**
   * Initializes the service by fetching and caching the device ID.
   * Must be called during app initialization before getDeviceId() is used.
   */
  public async init(): Promise<void> {
    const deviceId: DeviceId = await Device.getId();
    this.#deviceId = deviceId.identifier;
  }

  /**
   * Returns the unique device identifier.
   * On iOS: UUID unique to the app's vendor
   * On Android 8+: 64-bit number (hex string) unique to app-signing key, user, and device
   * @throws Error if init() has not been called
   */
  public getDeviceId(): string {
    if (this.#deviceId === null) {
      throw new Error('DeviceService not initialized. Call init() first.');
    }
    return this.#deviceId;
  }
}
